module.exports = __webpack_public_path__ + "static/media/LogoutIcon.88d29935.svg";